export const parseDistanceKm = (distanceLabel) => {
    if (!distanceLabel) return 0;
    const num = parseFloat(distanceLabel.replace(/[^\d.]/g, ''));
    return isNaN(num) ? 0 : num;
};

export const transformAndPriceResults = (rawResponse, totalDistanceKm) => {
    const rawResults = Array.isArray(rawResponse)
        ? rawResponse
        : (rawResponse?.Results ?? []);

    if (!rawResults.length) return [];

    const supplierMap = new Map();

    rawResults.forEach(result => {
        const supplier = result.Provider;
        const currency = result.ClientCurrency;
        const unitOptions = result.UnitRequestResults?.[0]?.Units ?? [];

        if (!supplierMap.has(supplier)) {
            supplierMap.set(supplier, { Supplier: supplier, ClientCurrency: currency, Units: [] });
        }

        const group = supplierMap.get(supplier);

        unitOptions.forEach(opt => {
            const pricePerKm = opt.UnitRate.ClientNetSell.Total ?? 0;
            const calculatedCost = totalDistanceKm > 0 && pricePerKm > 0
                ? parseFloat((pricePerKm * totalDistanceKm).toFixed(2))
                : pricePerKm;

            const alreadyAdded = group.Units.some(u => u.UnitTypeId === opt.UnitTypeId);
            if (!alreadyAdded) {
                group.Units.push({
                    UnitTypeId: opt.UnitTypeId,
                    ContractId: opt.ContractId ?? result.ContractId ?? null,
                    Name: opt.Name,
                    Cost: calculatedCost,
                    Currency: currency,
                    PricePerKm: pricePerKm,
                });
            }
        });
    });

    return Array.from(supplierMap.values());
};